/** Path 1 = broker partner; Path 2 = personal broker. */

export function accountMatchesSubscriptionPath(account, path) {
  const want = String(path || "").trim().toLowerCase();
  if (!want) return true;
  const got =
    account?.subscriptionPath != null
      ? String(account.subscriptionPath).trim().toLowerCase()
      : "";
  if (want === "path1") {
    // Never hide Connected / linked MT accounts from Path 1 unless explicit path2.
    if (got === "path2") return false;
    return true;
  }
  if (want === "path2") {
    if (got === "path1") return false;
    return true;
  }
  return true;
}

export function buildSlotsOwnedUrl(path) {
  const base = "/api/client/slots/owned";
  if (!path) return base;
  return `${base}?path=${encodeURIComponent(path)}`;
}
